export default {"src":"/_next/static/media/Pest_n_Diseases.579c090f.svg","height":32,"width":31};